import { render } from "./DistanceUnitSelector.vue?vue&type=template&id=349e4e5d&ts=true"
import script from "./DistanceUnitSelector.vue?vue&type=script&lang=ts"
export * from "./DistanceUnitSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__